import { Chip, Input } from './Ui';

/**
 * What the chosen category asks of this item (see the server's CategoryField).
 *
 * A hospital service is asked for its department and whether an appointment
 * is needed; a shirt for its size, colour and who it is for; a kiryana item
 * for nothing at all. Fields marked `optionalToggle` sit behind a switch -
 * "is this gender-specific?" - so a plain item is never made to answer.
 */
const CategoryFields = ({ fields = [], value = {}, toggles = {}, onChange, onToggle }) => {
  if (!fields.length) return null;
  const set = (key, v) => onChange({ ...value, [key]: v });

  return (
    <div>
      {fields.map((f) => {
        const many = Array.isArray(value[f.key]) ? value[f.key] : (value[f.key] ? [value[f.key]] : []);
        const hidden = f.optionalToggle && !toggles[f.key];
        return (
          <div key={f.key} style={{ marginBottom: 14 }}>
            {f.optionalToggle ? (
              <label className="switch" style={{ marginBottom: 6 }}>
                <input
                  type="checkbox"
                  checked={Boolean(toggles[f.key])}
                  onChange={(e) => { onToggle(f.key, e.target.checked); if (!e.target.checked) set(f.key, ''); }}
                />
                {f.label} — {f.hint || `turn on if this item is listed by ${f.label.toLowerCase()}`}
              </label>
            ) : (
              <>
                <label className="field-label">
                  {f.label}
                  {f.required ? <span style={{ color: 'var(--danger)' }}> *</span> : null}
                </label>
                {f.hint ? <div className="t-tiny" style={{ marginBottom: 6 }}>{f.hint}</div> : null}
              </>
            )}

            {hidden ? null : (
              <>
                {f.kind === 'select' ? (
                  <div className="row wrap" style={{ gap: 8 }}>
                    {f.options.map((o) => (
                      <Chip key={o} label={o} active={String(value[f.key] || '') === o} onClick={() => set(f.key, value[f.key] === o ? '' : o)} />
                    ))}
                  </div>
                ) : null}
                {f.kind === 'multi' ? (
                  <div className="row wrap" style={{ gap: 8 }}>
                    {f.options.map((o) => (
                      <Chip
                        key={o}
                        label={o}
                        active={many.includes(o)}
                        onClick={() => set(f.key, many.includes(o) ? many.filter((x) => x !== o) : [...many, o])}
                      />
                    ))}
                  </div>
                ) : null}
                {f.kind === 'yesno' ? (
                  <div className="row wrap" style={{ gap: 8 }}>
                    <Chip label="Yes" active={value[f.key] === 'yes'} onClick={() => set(f.key, 'yes')} />
                    <Chip label="No" active={value[f.key] === 'no'} onClick={() => set(f.key, 'no')} />
                  </div>
                ) : null}
                {['text', 'number'].includes(f.kind) ? (
                  <Input
                    placeholder={f.hint || f.label}
                    type={f.kind === 'number' ? 'number' : 'text'}
                    value={String(value[f.key] || '')}
                    onChange={(e) => set(f.key, e.target.value)}
                    style={{ marginBottom: 0 }}
                  />
                ) : null}
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CategoryFields;
